function validateFormOnBlur() {
  document.querySelectorAll('form.validate-on-blur').forEach((form) => {
    form.querySelectorAll('input, select, textarea').forEach((input) => {
      input.addEventListener('invalid', (e) => {
        e.preventDefault()
        let errorElement = e.target.closest('.field').querySelector('.error-message')
        errorElement.classList.remove('hidden')
        errorElement.textContent = input.validationMessage
      })
      input.addEventListener('blur', (e) => {
        form.reportValidity()
        if (input.reportValidity()) {
          let errorElement = e.target.closest('.field').querySelector('.error-message')
          errorElement.classList.add('hidden')
          errorElement.textContent = input.validationMessage
        }
      })
    })
  })  
}

document.addEventListener('turbo:load', validateFormOnBlur)
document.addEventListener('turbo:frame-load', validateFormOnBlur)